<script setup lang="ts">
import MagnifyingGlass from "~/components/icons/MagnifyingGlass.vue";
import XCircle from "~/components/icons/XCircle.vue";

const props = defineProps({
  modelValue: {
    type: [String, Boolean, Number],
    default: "",
  },
  errorMsg: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "Search...",
  },
});

// Data
const emit = defineEmits(["update:modelValue", "change", "blur"]);

const model = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    return emit("update:modelValue", value);
  },
});

// Functions
function onChange(event: any) {
  emit("change", event.target.value);
}

function onBlur(event: any) {
  emit("blur", event.target.value);
}
</script>

<template>
  <div class="relative rounded-2xl border border-gray-300 px-4 hover:border-gray-400">
    <input
      v-model="model"
      type="text"
      :placeholder="placeholder"
      class="w-full py-1 pl-2 text-base focus:outline-none"
      @change="onChange"
      @blur="onBlur"
    />

    <MagnifyingGlass v-show="!model" class="absolute right-4 top-0 w-4" />

    <XCircle v-show="model" class="absolute right-4 top-0 w-4 cursor-pointer" @click="model = ''" />
  </div>
</template>

<style scoped></style>
